import script from "./AtividadesCentralDoCoordenador.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadesCentralDoCoordenador.vue?vue&type=script&setup=true&lang=js"

import "./AtividadesCentralDoCoordenador.vue?vue&type=style&index=0&id=b0dd64cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0dd64cc"]])

export default __exports__